export const version = 'kunde-v1.19.0';